import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=245ba65b&scoped=true&"
import script from "./LoadingDialog.vue?vue&type=script&lang=js&"
export * from "./LoadingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ba65b",
  null
  
)

export default component.exports